import { useLang } from "@/i18n";
import { Reveal, LineMask } from "@/components/Reveal";

const Audiences = () => {
  const { t } = useLang();
  const a = t.audiences;

  return (
    <section className="audiences section-light" id="ecosistema" aria-labelledby="audiences-title" data-testid="audiences-section">
      <div className="shell">
        <div className="section-heading">
          <Reveal className="section-index dark" aria-hidden="true">{a.index}</Reveal>
          <div>
            <Reveal><p className="kicker dark">{a.kicker}</p></Reveal>
            <h2 id="audiences-title" className="display-title dark">
              <LineMask delay={0.1}>{a.titleA}</LineMask>
              <LineMask delay={0.22}><span>{a.titleB}</span></LineMask>
            </h2>
          </div>
        </div>

        <div className="audience-cards">
          {a.cards.map((card, i) => (
            <Reveal key={card.tag} className={`audience-card ${card.cls}`} delay={i * 0.1} data-testid={`audience-card-${card.cls}`}>
              <div className="audience-top"><span>{card.num}</span><small>{card.tag}</small></div>
              <h3>{card.title}</h3>
              <p>{card.text}</p>
              <ul>
                {card.list.map((item) => <li key={item}>{item}</li>)}
              </ul>
              <span className="audience-symbol" aria-hidden="true">{card.symbol}</span>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Audiences;
